import { join } from 'juriquery'

import { Query } from '../types'

export const CLINIC_AUDITS_ROOT_ROUTE = `/audits`
export const CLINIC_AUDITS_ROUTE = `${CLINIC_AUDITS_ROOT_ROUTE}/clinics/:clinicId`

export const getClinicAuditsRootRoute = (clinicId: number) =>
  CLINIC_AUDITS_ROUTE.replace(':clinicId', `${clinicId}`)

export const getClinicAuditsRoute = (clinicId: number, query?: Query) =>
  join(getClinicAuditsRootRoute(clinicId), query)
